import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
	DELAY_OPTIONS,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NOT_EMPTY,
	IS_NULL_OR_UNDEFINED,
} from 'cargo-chief-commons';

@Component({
	selector: 'app-project-group-dialog',
	templateUrl: './project-group-dialog.component.html',
	styleUrls: ['./project-group-dialog.component.scss'],
})
export class ProjectGroupDialogComponent implements OnInit {
	dialogTitle = 'Create Group';
	submitButtonText = 'Create';
	closeButtonText = 'Close';

	projectGroupForm: FormGroup = new FormGroup({
		name: new FormControl('', [Validators.required]),
		delayByMinutes: new FormControl('', [Validators.required]),
		projectId: new FormControl('', [Validators.required]),
		projectCarrierMapIdList: new FormControl([], [Validators.required]),
	});
	customDelayByMinutes!: number;

	DELAY_OPTIONS = DELAY_OPTIONS;

	constructor(
		public dialogRef: MatDialogRef<ProjectGroupDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any
	) {}

	ngOnInit() {
		this.projectGroupForm.get('projectId').setValue(this.dialogData.projectId);
		this.projectGroupForm
			.get('projectCarrierMapIdList')
			.setValue(this.dialogData.projectCarrierMapIds);
		let validGroupName = `Priority ${this.dialogData.totalNumberOfProjectGroups}`;
		let isGroupNameValid = this.isGroupNameValid(validGroupName);
		if (!isGroupNameValid) {
			let totalNumberOfProjectGroups = this.dialogData.totalNumberOfProjectGroups;
			while (!isGroupNameValid) {
				totalNumberOfProjectGroups += 1;
				validGroupName = `Priority ${totalNumberOfProjectGroups}`;
				isGroupNameValid = this.isGroupNameValid(validGroupName);
			}
		}
		let groupName = this.dialogData.editGroup ? this.dialogData.group.name : validGroupName;
		let delayByMinutes = null;
		if (this.dialogData.editGroup) {
			delayByMinutes = this.dialogData.group.delayByMinutes;
		} else if (this.dialogData.totalNumberOfProjectGroups == 1) {
			delayByMinutes = 0;
		}
		this.projectGroupForm.get('name').setValue(groupName);
		this.projectGroupForm.get('delayByMinutes').setValue(delayByMinutes);
		if (this.dialogData.editGroup) {
			this.dialogTitle = this.dialogData.dialogTitle;
			this.submitButtonText = this.dialogData.submitButtonText;
		}
	}

	updateDelayByMins(delay, customDelayOption: any = null) {
		this.projectGroupForm.get('delayByMinutes').setValue(+delay);
		if (customDelayOption?._element?.nativeElement) {
			customDelayOption._element.nativeElement.click();
		}
	}

	getSelectLabel(): string {
		const delayByMinutes = this.projectGroupForm?.value?.delayByMinutes;
		if (IS_NOT_NULL_OR_UNDEFINED(delayByMinutes)) {
			if (!delayByMinutes) {
				return `Immediate`;
			} else {
				return `${delayByMinutes} minutes`;
			}
		}
		return '';
	}

	submitForm() {
		let formValue = Object.assign({}, this.projectGroupForm.value);
		if (this.dialogData.editGroup) {
			formValue['projectGroupId'] = this.dialogData.group.id;
		}
		formValue.name = formValue.name.trim();
		this.closeDialog(formValue);
	}

	isGroupNameValid(groupName: string): boolean {
		return this.dialogData?.groupNames?.indexOf(groupName.toLowerCase()) === -1;
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
